import React from "react";
import { FiTrendingUp } from "react-icons/fi";
import {
  FaBookBookmark,
  FaEarthAmericas,
  FaRegAddressCard,
} from "react-icons/fa6";
import { FaChalkboardTeacher, FaSuitcase, FaUniversity } from "react-icons/fa";
import { CgExtensionAdd } from "react-icons/cg";
import { GrDocumentPerformance } from "react-icons/gr";
import { RiPresentationFill } from "react-icons/ri";
import { MdGroups, MdGroups2, MdLeaderboard } from "react-icons/md";
import { IoBagHandleSharp } from "react-icons/io5";
import { FaGraduationCap } from "react-icons/fa6";

import "./USP.css";
import { useSelector } from "react-redux";
import Disclaimer from "../Disclaimer";
import { PiBooksLight } from "react-icons/pi";
import { TbBooks } from "react-icons/tb";

const USP = () => {
  const { data } = useSelector((state) => state.program);

  return (
    <div
      id="unique points"
      className="USP second-bg-grad w-full flex justify-center py-12 xl:px-12 px-4"
    >
      <div className="w-full max-w-[85rem]">
        <div className="w-full text-center">
          <h4 className="text-base font-medium">
            Explore the unparalleled offerings for{" "}
            <span className="text-universal">{data?.short_title}</span> Program
          </h4>
          <h1 className="text-2xl md:text-3xl mt-2 font-semibold">
            Program <span className="text-universal">Strengths</span> at a
            Glance*
          </h1>
        </div>
        <div className="flex justify-center mt-12">
          <div className="w-full max-w-[75rem] grid grid-cols-2 xl:grid-cols-4 md:place-items-center gap-4 md:gap-8">
            {data?.unique_points?.includes("certificate") && (
              <div className="USP-card-bg-image py-4 md:py-6 px-3 md:px-5 bg-white rounded-lg flex flex-col items-center text-center md:max-w-sm md:min-h-[18rem] drop-shadow-2xl border cursor-context-menu overflow-hidden">
                <div className="w-16 h-16 mt-4 text-blue-600 flex-shrink-0">
                  <FaRegAddressCard className="w-full h-full" />
                </div>
                <h1 className="text-lg font-semibold mt-4">
                  Completion Certificate
                </h1>
                <h4 className="text-neutral-600 font-medium mt-2 text-[15px] max-md:hidden">
                  Receive a prestigious completion certificate, validating your
                  mastery and commitment to excellence.
                </h4>
              </div>
            )}
            {data?.unique_points?.includes("BYOP-challenge") && (
              <div className="USP-card-bg-image py-4 md:py-6 px-3 md:px-5 bg-white rounded-lg flex flex-col items-center text-center md:max-w-sm md:min-h-[18rem] drop-shadow-2xl border cursor-context-menu overflow-hidden">
                <div className="w-16 h-16 mt-4 text-blue-600 flex-shrink-0">
                  <FiTrendingUp className="w-full h-full" />
                </div>
                <h1 className="text-lg font-semibold mt-4">BYOP Challenge</h1>
                <h4 className="text-neutral-600 font-medium mt-2 text-[15px] max-md:hidden">
                  Put theory into action as you design and develop your unique
                  product.
                </h4>
              </div>
            )}
            {data?.unique_points?.includes("product-demo-day") && (
              <div className="USP-card-bg-image py-4 md:py-6 px-3 md:px-5 bg-white rounded-lg flex flex-col items-center text-center md:max-w-sm md:min-h-[18rem] drop-shadow-2xl border cursor-context-menu overflow-hidden">
                <div className="w-16 h-16 mt-4 text-blue-600 flex-shrink-0">
                  <RiPresentationFill className="w-full h-full" />
                </div>
                <h1 className="text-lg font-semibold mt-4">Product Demo Day</h1>
                <h4 className="text-neutral-600 font-medium mt-2 text-[15px] max-md:hidden">
                  Participate in showcasing innovative products to industry
                  experts and receive valuable feedback.
                </h4>
              </div>
            )}
            {data?.unique_points?.includes("campus-immersion") && (
              <div className="USP-card-bg-image py-4 md:py-6 px-3 md:px-5 bg-white rounded-lg flex flex-col items-center text-center md:max-w-sm md:min-h-[18rem] drop-shadow-2xl border cursor-context-menu overflow-hidden">
                <div className="w-16 h-16 mt-4 text-blue-600 flex-shrink-0">
                  <FaUniversity className="w-full h-full" />
                </div>
                <h1 className="text-lg font-semibold mt-4">
                  Campus <br className="md:hidden" /> Immersion
                </h1>
                <h4 className="text-neutral-600 font-medium mt-2 text-[15px] max-md:hidden">
                  Experience a transformative learning journey on campus with
                  insights from industry professionals.
                </h4>
              </div>
            )}
            {data?.unique_points?.includes("add-ons") && (
              <div className="USP-card-bg-image py-4 md:py-6 px-3 md:px-5 bg-white rounded-lg flex flex-col items-center text-center md:max-w-sm md:min-h-[18rem] drop-shadow-2xl border cursor-context-menu overflow-hidden">
                <div className="w-16 h-16 mt-4 text-blue-600 flex-shrink-0">
                  <CgExtensionAdd className="w-full h-full" />
                </div>
                <h1 className="text-lg font-semibold mt-4">
                  Add-on <br className="md:hidden" /> Modules
                </h1>
                <h4 className="text-neutral-600 font-medium mt-2 text-[15px] max-md:hidden">
                  Explore specialized modules that expand your knowledge and
                  equip you with advanced skills.
                </h4>
              </div>
            )}
            {data?.unique_points?.includes("experiential-learning") && (
              <div className="USP-card-bg-image py-4 md:py-6 px-3 md:px-5 bg-white rounded-lg flex flex-col items-center text-center md:max-w-sm md:min-h-[18rem] drop-shadow-2xl border cursor-context-menu overflow-hidden">
                <div className="w-16 h-16 mt-4 text-blue-600 flex-shrink-0">
                  <GrDocumentPerformance className="w-full h-full" />
                </div>
                <h1 className="text-lg font-semibold mt-4">
                  Experiential Learning
                </h1>
                <h4 className="text-neutral-600 font-medium mt-2 text-[15px] max-md:hidden">
                  Engage in live projects and case studies to enhance skills
                  with expert guidance.
                </h4>
              </div>
            )}
            {data?.unique_points?.includes("international-immersion") && (
              <div className="USP-card-bg-image py-4 md:py-6 px-3 md:px-5 bg-white rounded-lg flex flex-col items-center text-center md:max-w-sm md:min-h-[18rem] drop-shadow-2xl border cursor-context-menu overflow-hidden">
                <div className="w-16 h-16 mt-4 text-blue-600 flex-shrink-0">
                  <FaEarthAmericas className="w-full h-full" />
                </div>
                <h1 className="text-lg font-semibold mt-4">
                  Dual Immersive Experiences
                </h1>
                <h4 className="text-neutral-600 font-medium mt-2 text-[15px] max-md:hidden">
                  Engage in leadership-focused immersions at IIMV and the global
                  business hub of Dubai.
                </h4>
              </div>
            )}
            {data?.unique_points?.includes("engaging-simulations") && (
              <div className="USP-card-bg-image py-4 md:py-6 px-3 md:px-5 bg-white rounded-lg flex flex-col items-center text-center md:max-w-sm md:min-h-[18rem] drop-shadow-2xl border cursor-context-menu overflow-hidden">
                <div className="w-16 h-16 mt-4 text-blue-600 flex-shrink-0">
                  <MdGroups2 className="w-full h-full" />
                </div>
                <h1 className="text-lg font-semibold mt-4">
                  Engaging Simulations
                </h1>
                <h4 className="text-neutral-600 font-medium mt-2 text-[15px] max-md:hidden">
                  Experience immersive simulations for strategic thinking in a
                  dynamic, risk-free environment.
                </h4>
              </div>
            )}
            {data?.unique_points?.includes("exclusive-merchandise") && (
              <div className="USP-card-bg-image py-4 md:py-6 px-3 md:px-5 bg-white rounded-lg flex flex-col items-center text-center md:max-w-sm md:min-h-[18rem] drop-shadow-2xl border cursor-context-menu overflow-hidden">
                <div className="w-16 h-16 mt-4 text-blue-600 flex-shrink-0">
                  <IoBagHandleSharp className="w-full h-full" />
                </div>
                <h1 className="text-lg font-semibold mt-4">
                  Exclusive Merchandise
                </h1>
                <h4 className="text-neutral-600 font-medium mt-2 text-[15px] max-md:hidden">
                  IIMV's exclusive merchandise kit: A meticulously curated gift
                  to enrich participants' experience.
                </h4>
              </div>
            )}
            {data?.unique_points?.includes("mentoring-session") && (
              <div className="USP-card-bg-image py-4 md:py-6 px-3 md:px-5 bg-white rounded-lg flex flex-col items-center text-center md:max-w-sm md:min-h-[18rem] drop-shadow-2xl border cursor-context-menu overflow-hidden">
                <div className="w-16 h-16 mt-4 text-blue-600 flex-shrink-0">
                  <FaChalkboardTeacher className="w-full h-full" />
                </div>
                <h1 className="text-lg font-semibold mt-4">Career Session</h1>
                <h4 className="text-neutral-600 font-medium mt-2 text-[15px] max-md:hidden">
                  Participate in live mentoring sessions to break into your
                  desired career path.
                </h4>
              </div>
            )}
            {data?.unique_points?.includes("CXO-coaching-sessions") && (
              <div className="USP-card-bg-image py-4 md:py-6 px-3 md:px-5 bg-white rounded-lg flex flex-col items-center text-center md:max-w-sm md:min-h-[18rem] drop-shadow-2xl border cursor-context-menu overflow-hidden">
                <div className="w-16 h-16 mt-4 text-blue-600 flex-shrink-0">
                  <FaChalkboardTeacher className="w-full h-full" />
                </div>
                <h1 className="text-lg font-semibold mt-4">
                  CXO Coaching Sessions
                </h1>
                <h4 className="text-neutral-600 font-medium mt-2 text-[15px] max-md:hidden">
                  Engage in CXO Coaching Sessions for strategic thinking in a
                  dynamic, risk-free environment.
                </h4>
              </div>
            )}
            {data?.unique_points?.includes("alumni-status") && (
              <div className="USP-card-bg-image py-4 md:py-6 px-3 md:px-5 bg-white rounded-lg flex flex-col items-center text-center md:max-w-sm md:min-h-[18rem] drop-shadow-2xl border cursor-context-menu overflow-hidden">
                <div className="w-16 h-16 mt-4 text-blue-600 flex-shrink-0">
                  <FaGraduationCap className="w-full h-full" />
                </div>
                <h1 className="text-lg font-semibold mt-4">
                  Executive Alumni Status
                </h1>
                <h4 className="text-neutral-600 font-medium mt-2 text-[15px] max-md:hidden">
                  Unlock exclusive opportunities by attaining Executive Alumni
                  Status.
                </h4>
              </div>
            )}
            {data?.unique_points?.includes("alumni-status-iit") && (
              <div className="USP-card-bg-image py-4 md:py-6 px-3 md:px-5 bg-white rounded-lg flex flex-col items-center text-center md:max-w-sm md:min-h-[18rem] drop-shadow-2xl border cursor-context-menu overflow-hidden">
                <div className="w-16 h-16 mt-4 text-blue-600 flex-shrink-0">
                  <FaGraduationCap className="w-full h-full" />
                </div>
                <h1 className="text-lg font-semibold mt-4">Alumni Status</h1>
                <h4 className="text-neutral-600 font-medium mt-2 text-[15px] max-md:hidden">
                  Unlock exclusive opportunities by attaining E&ICT IIT Guwahati
                  Alumni Status.
                </h4>
              </div>
            )}
            {data?.unique_points?.includes("leadership-driven-learning") && (
              <div className="USP-card-bg-image py-4 md:py-6 px-3 md:px-5 bg-white rounded-lg flex flex-col items-center text-center md:max-w-sm md:min-h-[18rem] drop-shadow-2xl border cursor-context-menu overflow-hidden">
                <div className="w-16 h-16 mt-4 text-blue-600 flex-shrink-0">
                  <MdGroups className="w-full h-full" />
                </div>
                <h1 className="text-lg font-semibold mt-4">
                  Leadership-Driven Learning
                </h1>
                <h4 className="text-neutral-600 font-medium mt-2 text-[15px] max-md:hidden">
                  Gain AI fluency through a curriculum built for innovation and
                  strategic impact.
                </h4>
              </div>
            )}

            {data?.unique_points?.includes("case-based-learning") && (
              <div className="USP-card-bg-image py-4 md:py-6 px-3 md:px-5 bg-white rounded-lg flex flex-col items-center text-center md:max-w-sm md:min-h-[18rem] drop-shadow-2xl border cursor-context-menu overflow-hidden">
                <div className="w-16 h-16 mt-4 text-blue-600 flex-shrink-0">
                  <TbBooks className="w-full h-full" />
                </div>
                <h1 className="text-lg font-semibold mt-4">
                  Case Based Learning
                </h1>
                <h4 className="text-neutral-600 font-medium mt-2 text-[15px] max-md:hidden">
                  Analyze real-world AI use cases to strengthen strategic
                  problem-solving and decision-making skills.
                </h4>
              </div>
            )}
          </div>
        </div>
        <Disclaimer ClassName={"text-sm mt-8 text-center"} />
      </div>
    </div>
  );
};

export default USP;
